import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import CloseIcon from '@mui/icons-material/Close'
import OpenInFullIcon from '@mui/icons-material/OpenInFull'
import { ASSISTANT_NAME } from './copy'
import SparkleIcon from './SparkleIcon'

interface AssistantHeaderProps {
  onStartOver: () => void
  canStartOver: boolean
  /** Docked panel only: open the full page. */
  onExpand?: () => void
  /** Docked panel only: close the panel. */
  onClose?: () => void
  /** Id on the title, so the panel can be named by it. */
  titleId?: string
}

const AssistantHeader = ({
  onStartOver,
  canStartOver,
  onExpand,
  onClose,
  titleId,
}: AssistantHeaderProps) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      // Tight enough that the full name fits beside Clear, expand and close
      // in the 400px docked panel; phones still shorten it with an ellipsis.
      gap: 0.75,
      minHeight: 60,
      flexShrink: 0,
      pl: 2,
      pr: 1.5,
      borderBottom: 1,
      borderColor: 'divider',
      bgcolor: 'background.paper',
    }}
  >
    <SparkleIcon twoTone color="primary" />
    <Typography
      id={titleId}
      variant="h6"
      component="h1"
      fontWeight={700}
      noWrap
      sx={{ flex: 1, minWidth: 0 }}
    >
      {ASSISTANT_NAME}
    </Typography>
    <Tooltip title="Clear this conversation from this browser">
      <span>
        <Button
          size="small"
          onClick={onStartOver}
          disabled={!canStartOver}
          data-testid="assistant-clear"
          sx={{ minWidth: 0, '&:disabled': { bgcolor: 'transparent' } }}
        >
          Clear
        </Button>
      </span>
    </Tooltip>
    {onExpand && (
      <Tooltip title="Open full page">
        <IconButton size="small" aria-label="Open full page" onClick={onExpand}>
          <OpenInFullIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    )}
    {onClose && (
      <Tooltip title="Close">
        <IconButton size="small" aria-label="Close" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    )}
  </Box>
)

export default AssistantHeader
